/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_ProviderInputs */

const en_settings_billing_provider = /** @type {(inputs: Settings_Billing_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Settings_Billing_ProviderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_provider = /** @type {((inputs?: Settings_Billing_ProviderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_ProviderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_provider(inputs)
});
export { settings_billing_provider as "settings.billing.provider" }